// src/components/games/pipsCreatureKeeper/VictoryScreen.tsx
// FIXED: Much smaller popup overlay with compact styling

import React, { useEffect } from 'react';
import { IonButton, IonIcon } from '@ionic/react';
import { trophy, star } from 'ionicons/icons';
import './VictoryScreen.css';

interface VictoryScreenProps {
  keeperName: string;
  totalCreatures: number;
  onClose: () => void;
}

const VictoryScreen: React.FC<VictoryScreenProps> = ({ keeperName, totalCreatures, onClose }) => {
  useEffect(() => {
    // Create confetti particles (reduced count)
    const colors = ['#FFD700', '#FF6B6B', '#4ECDC4', '#45B7D1', '#FFA07A'];
    const confettiCount = 30;
    const container = document.querySelector('.victory-overlay');

    if (container) {
      for (let i = 0; i < confettiCount; i++) {
        setTimeout(() => {
          const confetti = document.createElement('div');
          confetti.className = 'victory-confetti';
          confetti.style.left = `${Math.random() * 100}%`;
          confetti.style.backgroundColor = colors[Math.floor(Math.random() * colors.length)];
          confetti.style.animationDelay = `${Math.random() * 0.5}s`;
          confetti.style.animationDuration = `${2 + Math.random() * 1}s`;
          container.appendChild(confetti);

          setTimeout(() => confetti.remove(), 4000);
        }, i * 30);
      }
    }
  }, []);

  return (
    <div className="victory-overlay" onClick={onClose}>
      <div className="victory-content" onClick={(e) => e.stopPropagation()}>
        <div className="victory-trophy">🏆</div>

        <h1 className="victory-title">Sanctuary Restored!</h1>

        <p className="victory-message">
          Congratulations, <strong>{keeperName}</strong>!
          You've captured all {totalCreatures} creatures.
        </p>

        <div className="victory-stats">
          <div className="victory-stat">
            <IonIcon icon={trophy} />
            <span>Master Keeper</span>
          </div>
        </div>

        <IonButton
          expand="block"
          color="success"
          size="small"
          className="victory-button"
          onClick={onClose}
        >
          Continue
        </IonButton>
      </div>
    </div>
  );
};

export default VictoryScreen;